import { Stack } from '@mui/material';
import React from 'react';

import type { BoxItemProps } from '../BoxItem';
import BoxItem from '../BoxItem';
import BoxItemSkeleton from '../BoxItem/BoxItemSkeleton';

const DEFAULT_SKELETON_COUNT = 5;

export interface BoxItemStackProps {
  items: BoxItemProps[];
  loading?: boolean;
  skeletonCount?: number;
}

const BoxItemStack: React.FC<BoxItemStackProps> = ({
  items,
  loading = false,
  skeletonCount = DEFAULT_SKELETON_COUNT,
}) => {
  if (loading) {
    return (
      <Stack spacing={0} sx={{ width: '100%' }}>
        {Array.from({ length: skeletonCount }, (_, i) => (
          <BoxItemSkeleton key={`skeleton-${i}`} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={0} sx={{ width: '100%' }}>
      {items.map((item, index) => (
        <BoxItem
          key={`${item.primaryText}-${index}`}
          primaryText={item.primaryText}
          amount={item.amount}
          secondaryText={item.secondaryText}
          chipText={item.chipText}
          chipType={item.chipType}
          onClick={item.onClick}
        />
      ))}
    </Stack>
  );
};

export default BoxItemStack;
